<template>
  <v-progress-circular
    indeterminate
    size="50"
    width="4"
    color="primary"
  ></v-progress-circular>
</template>

<script>
export default {
  name: "CKEditorLoading",
};
</script>

<style></style>
